import { render, staticRenderFns } from "./zeroKnowedge.vue?vue&type=template&id=3523caac&scoped=true&"
import script from "./zeroKnowedge.vue?vue&type=script&lang=js&"
export * from "./zeroKnowedge.vue?vue&type=script&lang=js&"
import style0 from "./zeroKnowedge.vue?vue&type=style&index=0&id=3523caac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523caac",
  null
  
)

export default component.exports